import { render, staticRenderFns } from "./ReminderDailyReport.vue?vue&type=template&id=6a58dc3e&scoped=true&"
import script from "./ReminderDailyReport.vue?vue&type=script&lang=js&"
export * from "./ReminderDailyReport.vue?vue&type=script&lang=js&"
import style0 from "./ReminderDailyReport.vue?vue&type=style&index=0&id=6a58dc3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58dc3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VImg})
